var map = {
	"./Durham_stamp.svg": 73,
	"./activities.svg": 74,
	"./bid-icon-pink.svg": 75,
	"./bid-icon-white.svg": 76,
	"./bid-icon.svg": 77,
	"./billyBatesFunfair.svg": 78,
	"./cafe.svg": 79,
	"./christmas.svg": 80,
	"./dinner.svg": 81,
	"./entertainment.svg": 82,
	"./events.svg": 83,
	"./family.svg": 84,
	"./gift_card.svg": 85,
	"./iceRink.svg": 86,
	"./independant.svg": 87,
	"./interactiveAdventure.svg": 88,
	"./leicester-icon.svg": 89,
	"./lunch.svg": 90,
	"./movieNights.svg": 91,
	"./nativityScene.svg": 92,
	"./nightclubs.svg": 93,
	"./pubs_bars.svg": 94,
	"./rhizome.svg": 95,
	"./santaSquare.svg": 96,
	"./shopping.svg": 97,
	"./sweet_treat.svg": 98,
	"./wheelOfLight.svg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;